import { render, staticRenderFns } from "./LeaderboardUserTable.vue?vue&type=template&id=627a937c&scoped=true&"
import script from "./LeaderboardUserTable.vue?vue&type=script&lang=js&"
export * from "./LeaderboardUserTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardUserTable.vue?vue&type=style&index=0&id=627a937c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a937c",
  null
  
)

export default component.exports